import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { ContinueButton, ErrorBlockLarge, Footer, PreviousButton } from '../../CourseCreationFlow/styles';
import { Box, Typography } from '@mui/material';
import SampleCourseViewModal from '../SampleCourseViewModal/sampleCourseViewModal';
import { stepsFooterSx } from './styles';

export const StepsFooter = ({ handleDec, handleContinueClick, error, status, isLoading }) => {
    const [openSample, setOpenSample] = useState(false);
    const courseSteps = useSelector((state) => state.courseSteps.courseSteps);
    const basicStepState = useSelector((state) => state.courseSteps.basicStepState);
    return (
        <>
            <SampleCourseViewModal openSample={openSample} setOpenSample={setOpenSample} />
            <Footer>
                <Grid container  sx={stepsFooterSx.gridRoot}>
                    <Grid item sx={stepsFooterSx.leftGrid}>
                        {courseSteps > 1 && (
                            <PreviousButton
                                variant="contained"
                                onClick={handleDec}
                                disabled={isLoading}
                            >
                                Previous
                            </PreviousButton>
                        )}
                    </Grid>
                    <Grid item sx={stepsFooterSx.rightGrid}>
                        <Box
                            height={error ? 'auto' : '24px'}
                            sx={{
                                ...stepsFooterSx.errorBox,
                                width: { md: error && '300px' },
                            }}
                        >
                            {error && <ErrorBlockLarge>{error}</ErrorBlockLarge>}
                        </Box>
                        <ContinueButton
                            variant="contained"
                            disabled={isLoading || (courseSteps === 1 && !basicStepState.categoryValue)}
                            onClick={handleContinueClick}
                        >
                            {courseSteps <= 5 ? "Continue" : status ? "Finish" : "Submit For Approval"}
                        </ContinueButton>
                    </Grid>
                    {courseSteps <= 5 && (
                        <Box
                            position="absolute"
                            left="50%"
                            top="50%"
                            sx={stepsFooterSx.sampleBox}
                        >
                            <Typography component="span" sx={stepsFooterSx.sampleText}>Not sure what to put?</Typography>
                            <Typography
                                component="span"
                                color="primary"
                                textTransform="capitalize"
                                sx={stepsFooterSx.sampleLink}
                                onClick={() => setOpenSample(true)}
                            >
                                View a Sample Listing
                            </Typography>
                        </Box>
                    )}
                </Grid>
            </Footer>
        </>
    );
};
